export enum PointConfigurationApplicationModeEnum {
  ONLY_DAILY = "ONLY_DAILY",
  ONLY_HOLIDAYS = "ONLY_HOLIDAYS",
  ALWAYS = "ALWAYS",
}
